export enum EXTENSION_MESSAGE {
    LOGOUT = 'logout',
    SCRAPPED_DATA = 'scrapped-data'
  }
